import { Component, ChangeDetectorRef, ViewChild} from "@angular/core";
import { NavController, ModalController, AlertController, Content } from "ionic-angular";
import { PopoverController, Platform, NavParams, Events } from "ionic-angular";
import { ToastController } from "ionic-angular";
import { SettingsPage } from "../settings/settings";
import { Imybook, ImyDownloadBooks } from "../../../models/mybook";
import { EventListener } from "./event-listener";
import { FirebaseService } from "../../../services/firebase.service";
import { ImybookMarks } from "../../../models/myBookMarks";
import { Observable } from "rxjs";
import { ImyBookHighlight } from "../../../models/myBookHighlight";

declare var ePub: any;
declare var window: any;

@Component({
  selector: "page-book",
  templateUrl: "book.html"
})
export class BookPage {
  @ViewChild(Content) content: Content;

  tabBarElement: any;
  bookElement: any;

  eventListener: EventListener;
  rendition: any;
  book: any;
  bookParam: Imybook;
  UserDowloadBooks: ImyDownloadBooks[]; //insieme dei libri con file in locale
  UserLocalBook: ImyDownloadBooks;
  bookmarks: ImybookMarks[] = [];
  highlights: ImyBookHighlight[] = [];
  params: any = { bookmarked: false, excerpt: "", position: undefined, showToolbars: true };
  toc: any = [];
  lastlocation: string;

  LoadinOK:boolean = false;

  isDesktop:boolean =false;

  constructor(
    public popoverCtrl: PopoverController,
    public modalbook: ModalController,
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public platform: Platform,
    public events: Events,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private FireSrvc: FirebaseService,
    private ref: ChangeDetectorRef,
    

  ) {
    this.tabBarElement = document.querySelector(".tabbar.show-tabbar");

    this.bookParam = this.navParams.get("book");
    this.platform.ready().then(() => {

    if (this.platform.is("core")){

        this.isDesktop = true;
        console.log(this.isDesktop)
      };
      // debugger;

      // Cerco dal locale quel è il libro da caricare in locale
      if (localStorage.getItem("UserDowloadBooks")) {
        this.UserDowloadBooks = JSON.parse(localStorage.getItem("UserDowloadBooks"));
        this.content.resize();
        // Cerco l'elemento da leggere
      //  this.UserLocalBook = this.UserDowloadBooks.find(item => item.id === this.bookParam.id)
      }

      // Carico il file dal locale
    //   if (this.UserLocalBook === undefined){
    //     console.log("apertura file REMOTO - errore")
    //     this.book = ePub(this.bookParam.ePubUrl);
    // }else{
    //     if (this.UserLocalBook.status === 'offline') {
    //     console.log("apertura file LOCALE")
    //       console.dir(this.UserLocalBook.ePubLocal);
    //     this.book = ePub(this.UserLocalBook.ePubLocal);
    //   } else {
    //     console.log("apertura file REMOTO")
    //       console.dir(this.bookParam.ePubUrl);
    //       console.dir(this.UserLocalBook.ePubLocal);
    //     this.book = ePub(this.bookParam.ePubUrl);
    //   }
    // }

      console.log(this.bookParam.title)
      this.book = ePub(this.bookParam.ePubUrl);
      // this.params.showToolbars = false;

      let toast = this.toastCtrl.create({
        message: 'Caricamento in corso...',
        // duration: 3000,
        position: 'top'
      });

      toast.present();

      this.book.ready.then(() => {

        this.book.locations.generate(1500).then(locations => {
          const currentLocation = this.rendition.currentLocation();
          this.params.position = currentLocation.start ? this.book.locations.percentageFromCfi(currentLocation.start.cfi) : 0.001;
          //  console.log("locations -> " + locations);
         

  this.params.showToolbars = false;
          this.content.resize();
           this.ref.detectChanges();

           this.LoadinOK = true;
           toast.dismiss();

            toast = this.toastCtrl.create({
            message: 'Caricamento completato',
             duration: 3000,
            position: 'bottom'
          });
    
          toast.present();
          

        });
      });
      this.rendition = this.book.renderTo("book", {
        spread: "always"
      });

      this.lastlocation = this.bookParam.current_page

        this.rendition.display(this.lastlocation).then(() => {
          this._applyStyle();
         this._appendDbHighlights();
          this.content.resize();
        });

      this._registerThemes();
      this.book.loaded.navigation.then(navigation => {
        this.toc = navigation.toc;
      });

      this.rendition.on("relocated", location => {
        this.lastlocation = this.rendition.location.start.cfi;
        this._addlastLocation();
        const currentLocation = this.rendition.currentLocation();
        this.params.position = this.params.position != undefined ? this.book.locations.percentageFromCfi(currentLocation.start.cfi) : undefined;
        this._getCurrentLocationExcerpt(location);
        this._checkIfBookmarked(location);
        // console.log(this.rendition.manager.container.firstChild.firstChild.contentDocument);
        this._addSwipeEvents(this.rendition.manager.container.firstChild.firstChild.contentDocument);
        this.ref.detectChanges();
      });

      // Apply a class to selected text
      this.rendition.on("selected", (cfiRange, contents) => {
       this.addHighlight(cfiRange, contents);
      });
    });
    this._subscribeToEvents();
  }

  // 1.0.2 - Sostiutzione DBql con Firebase - OK
  private _applyStyle() {

   // this.rendition.themes.override("font-family", this.bookParam.fontfamily);
    this.rendition.themes.override("font-size", this.bookParam.fontsize + 'em');
    this.rendition.themes.select(this.bookParam.color);

  }

  ionViewWillLeave() {

    // this.events.publish("mybook:ExitRead", "");

    try {
      this.tabBarElement.style.display = "flex";
    } catch (error) {

    }
  }

// 1.0.2 - Sostiutzione DBql con Firebase  - OK
  ionViewWillEnter() {
    this.tabBarElement.style.display = "none";

//gesrisce il colore dello sfondo
    this.bookElement = document.getElementsByClassName("bk");

    let colorbk: string
    if (this.bookParam.color === "tan"){
      colorbk = "rgb(249, 241, 228)"
    }else{
      colorbk = this.bookParam.color
    }
    this.bookElement[0].style.backgroundColor = colorbk;

 // 1.0.2 - Sostiutzione DBql con Firebase  - OK
    this.FireSrvc.getBookmarksByBookId(this.bookParam.id).subscribe(
      (resmy: [ImybookMarks]) => {
        this.bookmarks = resmy;

      },
      err => {
        Observable.throw(err);
        console.log(err);
    });
  }

 // 1.0.2 - Sostiutzione DBql con Firebase  - OK
  private _appendDbHighlights() {

    this.FireSrvc.getHighlightByBookId(this.bookParam.id).subscribe(
      (resmy: [ImyBookHighlight]) => {
        this.highlights = resmy;
        resmy.forEach(highlight => {
          this.rendition.annotations.highlight(highlight.cfiRange, { text: highlight.text }, e => {
            this.highlightPopup(e);
          });
        });
      },
      err => {
        Observable.throw(err);
        console.log(err);
      });
  }

   // 1.0.2 - Sostiutzione DBql con Firebase  - OK
  private _addlastLocation() {


    this.bookParam.current_page = this.lastlocation
    this.FireSrvc.UpdateMyBook(this.bookParam)

   // this.dbService.addlastLocation(this.lastlocation);
  }

 // 1.0.2 - Sostiutzione DBql con Firebase  - OK
  private addHighlight(cfiRange: any, contents: any) {

     this.rendition.annotations.highlight(cfiRange, { text: contents.window.getSelection().toString() }, e => {
       this.highlightPopup(e);
       console.log(e);
     });

     let ranges = cfiRange.split(",/");
    let highlight: ImyBookHighlight = {
       bookid: this.bookParam.id,
       text: contents.window.getSelection().toString(),
       location: ranges[0] + "/" + ranges[1] + ")",
       position: this.params.position,
       cfiRange: cfiRange
     };
     this.highlights.push(highlight);
    this.FireSrvc.UpdateMyHighlight(highlight);
     contents.window.getSelection().removeAllRanges();
  }

 // 1.0.2 - Sostiutzione DBql con Firebase  - OK
  private highlightPopup(e: any) {
    const confirm = this.alertCtrl.create({
      title: "Evidenziature",
      message: e.target.dataset.text,
      buttons: [
        {
          text: "Chiudi",
          role: "cancel",
          handler: data => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Elimina",
          handler: () => {
            let highlight: ImyBookHighlight = {
            bookid: this.bookParam.id,
            cfiRange: e.target.dataset.epubcfi,
            text: e.target.dataset.text,
            }

            let Findhighlight = this.highlights.filter(item => item.text === highlight.text);
            this.FireSrvc.RemoveMyHighlight(Findhighlight[0]);

            this.events.publish("delete:highlight", highlight);
            console.log("Delete clicked");
          }
        }
      ]
    });
    confirm.present();
  }

  goToLocation() {
    const prompt = this.alertCtrl.create({
      title: "Vai a...",
      message: "inserisci la posizione in %",
      inputs: [
        {
          name: "location",
          placeholder: "posizione in %"
        }
      ],
      buttons: [
        {
          text: "annulla",
          handler: data => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "vai",
          handler: data => {

            this.rendition.display(this.book.locations.cfiFromPercentage(data.location / 100));

          }
        }
      ]
    });
    prompt.present();
  }

  _registerThemes(): any {
    this.rendition.themes.register("white", { body: { "background-color": "rgb(255, 255, 255)", color: "rgb(0,0,0)" } });
    this.rendition.themes.register("tan", { body: { "background-color": "rgb(249,241,228)", color: "rgb(0,0,0)" } });
    this.rendition.themes.register("grey", { body: { "background-color": "rgb(76,75,80)", color: "rgb(255,255,255)" } });
    this.rendition.themes.register("black", { body: { "background-color": "rgb(0,0,0)", color: "rgb(255,255,255)" } });
  }

  private _getCurrentLocationExcerpt(location: any) {
    let startCfi = new ePub.CFI(location.start.cfi);
    let endCfi = new ePub.CFI(location.end.cfi);
    let startRange = startCfi.toRange(this.rendition.manager.container.children[0].children[0].contentDocument);
    let endRange = endCfi.toRange(this.rendition.manager.container.children[0].children[0].contentDocument);

    let fullRange = document.createRange();
    if (startRange) {
      fullRange.setStart(startRange.startContainer, startRange.startOffset);
    }
    if (endRange) {
      fullRange.setEnd(endRange.startContainer, endRange.startOffset);
    }
    this.params.excerpt = fullRange.toString();
  }

  private _addSwipeEvents(renderer) {
    this.eventListener = new EventListener(renderer);
    // this.eventListener.removeContextMenu();
    this.eventListener.onLeft = () => {
      this.prev();
    };
    this.eventListener.onRight = () => {
      this.next();
    };
    this.eventListener.onCenter = () => {
      return this.toggleToolbars();
    };
    this.eventListener.run();
  }

   // 1.0.2 - Sostiutzione DBql con Firebase  - OK
   //#BUG: togliere evidenziatura dopo eliminazione
  _subscribeToEvents() {
    this.events.subscribe("select:location", location => {
      this.rendition.display(location);
    });

    this.events.subscribe("delete:highlight", highlight => {
   // 1.0.2 - Sostiutzione DBql con Firebase  - OK
      this.FireSrvc.RemoveMyHighlight(highlight);
     // this.dbService.deleteHighlight(highlight);
      this.rendition.annotations.remove(highlight.cfiRange);
      this.rendition.annotations.remove(highlight.cfiRange);

    });

     // 1.0.2 - Sostiutzione DBql con Firebase  - OK
    this.events.subscribe("delete:bookmark", bookmark => {
      let curentLocation = this.rendition.location.start.cfi;
      if (curentLocation == bookmark.location) {
        this.params.bookmarked = !this.params.bookmarked;
      }
      this.FireSrvc.RemoveMybookmarks(bookmark);
      console.log(bookmark);
     // this.removeBookmark(bookmark);
    });

     // 1.0.2 - Sostiutzione DBql con Firebase - OK
    // settings: change style
    this.events.subscribe("select:theme", theme => {

      this.rendition.themes.select(theme);
      this.bookParam.color = theme
      this.FireSrvc.UpdateMyBook(this.bookParam)

      let colorbk: string

      if (theme === "tan") {

        colorbk = "rgb(249, 241, 228)"

      } else {

        colorbk = theme
      }


      this.bookElement[0].style.backgroundColor = colorbk;


    });

     // 1.0.2 - Sostiutzione DBql con Firebase  - OK
    this.events.subscribe("select:font-family", family => {
      console.log(family);
     // this.rendition.themes.override("font-family", family);
      this.bookParam.fontfamily = family
      this.FireSrvc.UpdateMyBook(this.bookParam)

    });

     // 1.0.2 - Sostiutzione DBql con Firebase  - OK
    this.events.subscribe("select:font-size", size => {
      console.log(size);
      this.rendition.themes.override("font-size", size);
      this.bookParam.fontsize = size
      this.FireSrvc.UpdateMyBook(this.bookParam)

    });
  }

  _checkIfBookmarked(location) {
    let locations = this.bookmarks.map(bookmark => bookmark.location);
    this.params.bookmarked = locations.indexOf(location.start.cfi) > -1;
  }

  prev() {
if(this.LoadinOK ){
   this.rendition.prev();
}
  }

  next() {
    if(this.LoadinOK ){
    this.rendition.next();
    }
  }

  changePage(event) {
    if (event.velocityX < 0) {
      this.next();
    } else {
      this.prev();
    }
  }

  settings(ev) {
    let popover = this.popoverCtrl.create(SettingsPage, {data:this.bookParam});
    popover.present({ ev });
  }

  toggleToolbars() {
    
       this.params.showToolbars = !this.params.showToolbars;
    this.ref.detectChanges();
    
   
  }

  backToBookList() {
    this.bookParam.status = this.params.position
    console.log(this.params.position)
    this.FireSrvc.UpdateMyBook(this.bookParam)
    this.navCtrl.pop();
     this.events.publish("mybook:ExitRead","");

    // this.navCtrl.setRoot(BooksLocalPage, {}, { animate: true, direction: "back" });

  }

  openModalBookDetails() {
    const myModalBook = this.modalbook.create("BookDetailsModal", {
      toc: this.toc,
      bookmarks: this.bookmarks,
      highlights: this.highlights
    });
    myModalBook.onDidDismiss(() => {
      this.ionViewWillEnter();
    });
    myModalBook.present();
  }

  // 1.0.2 - Sostiutzione DBql con Firebase - OK
  bookmarking() {

    let curentLocation:string = this.rendition.location.start.cfi;


    let bookmark: ImybookMarks = {
      id: this.params.id,
      bookid: this.bookParam.id,
      location: curentLocation,
      position: this.params.position,
      excerpt: this.params.excerpt
    };

    if (!this.params.bookmarked) {



      this.FireSrvc.UpdateMybookmarks(bookmark);
      this.bookmarks.push(bookmark);

    //  this.dbService.addBookMark(bookmark);
    } else {

     let Findbookmark = this.bookmarks.filter(item => item.location === bookmark.location);
      this.removeBookmark(Findbookmark[0]);
    }
    this.params.bookmarked = !this.params.bookmarked;

    const toast = this.toastCtrl.create({
      duration: 1000,
      position: "middle",
      cssClass: this.params.bookmarked ? "addBookmark" : "removeBookmark"
    });
    toast.present();
  }

// 1.0.2 - Sostiutzione DBql con Firebase - OK
  removeBookmark(bookmark: ImybookMarks) {
    let index = this.bookmarks.map(bookmark => bookmark.location).indexOf(bookmark.location);
    this.bookmarks.splice(index, 1);
    this.FireSrvc.RemoveMybookmarks(bookmark);

  }

}



// WEBPACK FOOTER //
// ./src/pages/BOOK-READER/book/book.ts